module.exports = __webpack_public_path__ + "static/media/29FUNOV9.e6937a02.jpg";